import { Colors, Services, getServiceNameViaPoint } from '@sigma-frontend-libs/commons'

import { icons, permissionPresets } from '@/utils'

import { urlShortenerSettingsDomainsStates } from '@/components/services/url-shortener-settings/domains/utils'
import { serviceNameViaPoint } from '@/components/services/url-shortener-settings/presets/utils'

import render from './render'

export default {
  name: 'Item',

  props: {
    value: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    canGetUsers() {
      return this.checkPermissions(`advanced.${Services.users}.get`, permissionPresets.resellerUp)
    },

    domainStickerProps() {
      const domainId = this.value.domainId ?? this.value.domain?.id
      const result = {
        value: this.value.domain ?? domainId,
        label: this.getTranslate(`${serviceNameViaPoint}.labels.domainId`),
        service: Services['url-shortener-settings/domains'],
        pathToTitle: 'name',
        copy: true,
        icon: icons.domain,
        color: Colors.grey,
        to: {
          name: `${getServiceNameViaPoint(Services['url-shortener-settings/domains'])}.single`,
          params: { id: domainId }
        }
      }
      const state = this.value?.domain?.state
      if (state) {
        result.icon = urlShortenerSettingsDomainsStates[state].icon
        result.color = urlShortenerSettingsDomainsStates[state].color
        result.iconTooltip = this.getTranslate(`${getServiceNameViaPoint(Services['url-shortener-settings/domains'])}.states.${state}`)
      }

      return result
    }
  },

  render
}
